import { DataType } from '@vgtv/api-client/lib/component';

import { isSvpAsset } from '../helpers';

import type { Component } from '@vgtv/api-client/lib/component';

function getComponentPresetIds(componentConfiguration: Component) {
  const dataPreset = componentConfiguration?.data?.preset ?? [];

  if (componentConfiguration?.data?.type === DataType.MIXED) {
    return (
      componentConfiguration?.data?.preset?.map((entity) =>
        isSvpAsset(entity) ? `asset:${entity.id}` : `category:${entity.id}`
      ) ?? []
    );
  }

  return dataPreset.map((entity) => entity.id);
}

/**
 * Given a Page it iterates over the embedded Components
 * and extracts the ids of Assets, Categories or Profiles in the Component data presets.
 *
 * Returns a collection of components and their respective dataIds.
 * NOTE: if a component has no preset it will be omitted.
 */
function getPageComponentsWithPresetIds<
  T extends Component,
>(pageConfiguration: { components: T[] }) {
  const { components = [] } = pageConfiguration;

  return components
    .map((component) => {
      const dataIds = getComponentPresetIds(component);

      return { component, dataIds };
    })
    .filter(({ dataIds }) => dataIds.length > 0);
}

export { getPageComponentsWithPresetIds };
